export const autocomleteInputOffProps = {
  autoComplete: 'nope',
  list: 'autocompleteOff',
  autoCorrect: 'off',
  spellCheck: 'off',
  autoCapitalize: 'on',
}

export const emailInputProps = {
  autoComplete: 'nope',
  list: 'autocompleteOff',
  autoCorrect: 'off',
  spellCheck: 'off',
  inputMode: 'email',
  autoCapitalize: 'off',
}

export const decimalInputProps = {
  autoComplete: 'nope',
  list: 'autocompleteOff',
  autoCorrect: 'off',
  spellCheck: 'off',
  inputMode: 'decimal',
  autoCapitalize: 'off',
}

export const numericInputProps = {
  autoComplete: 'nope',
  list: 'autocompleteOff',
  autoCorrect: 'off',
  spellCheck: 'off',
  inputMode: 'numeric',
  autoCapitalize: 'off',
}

export const passwordInputProps = {
  autoComplete: 'nope',
  list: 'autocompleteOff',
  autoCorrect: 'off',
  spellCheck: 'off',
  autoCapitalize: 'off',
}
